module.exports = __webpack_public_path__ + "static/img/note_2.bde55c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/note_2.png
// module id = 3txG
// module chunks = 1